import { render, staticRenderFns } from "./AppSkeleton.vue?vue&type=template&id=458bb9ff&"
import script from "./AppSkeleton.vue?vue&type=script&lang=js&"
export * from "./AppSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports